if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        /* CO2Art 2026-09-20 (push C, co2art-ai R-NEW156): the answer can arrive during the delay — carried from another of our market
           hosts by assets/co2art.js — so the decision to show is taken when the banner is about to open, not 5 s earlier. */
        setTimeout(() => {
          this.whenGeoSettled(() => {
            try {
              const answered = window.Shopify?.customerPrivacy?.getTrackingConsent?.();
              if (answered && answered !== 'no_interaction') return;
            } catch (e) { /* no API: the banner behaves as before */ }
            this.show();
          });
        }, delay * 1000);
    
        if (this.acceptButton) this.on(this.acceptButton, 'click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.on(this.declineButton, 'click', this.declinePolicy.bind(this));
      }
    
      /* CO2Art 2026-09-22 (Karol: "na .eu dostaję dwa razy zapytanie o akceptację cookies"; co2art-ai
         docs/plans/2026-09-22-cookie-banner-after-geo-bar.md): one question at a time. While the local-store bar offers this visitor their
         market domain (assets/local-store-bar.js: window.co2artGeo 'pending' | 'offer'), the banner waits — a Yes takes the visitor to that
         domain, which asks once and in their language; a No ('closed') or no offer ('none') shows the banner here; 'leaving' never shows it.
         A bar still 'pending' after 3 s holds nothing back. */
      whenGeoSettled(fn) {
        const state = window.co2artGeo;
        if (state === 'leaving') return;
        if (state !== 'pending' && state !== 'offer') { fn(); return; }
        let done = false;
        const finish = (show) => {
          if (done) return;
          done = true;
          document.removeEventListener('co2art:geo', onGeo);
          if (show) fn();
        };
        const onGeo = (event) => {
          const next = event.detail && event.detail.state;
          if (next === 'none' || next === 'closed') finish(true);
          else if (next === 'leaving') finish(false);
        };
        document.addEventListener('co2art:geo', onGeo);
        if (state === 'pending') setTimeout(() => { if (window.co2artGeo === 'pending') finish(true); }, 3000);
      }
    
      acceptPolicy() {
        this.hide();
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.noop);
      }
    
      declinePolicy() {
        this.hide();
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.noop);
      }
    
      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    
        if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
